import { createNotificationManager } from './manager';
import { NotificationManager } from './_types';

const notificationManagerInstance: NotificationManager = createNotificationManager();

export default notificationManagerInstance;
